import _get from 'lodash/get';

export default pickUp =>
  `${_get(pickUp, 'poi.id')}-${_get(pickUp, 'name')}-${_get(pickUp, 'phone')}`;
